<template>
    <div>
        <vehicle-form  @go-back="$emit('close-dialog', true)" :handler="createVehicle" :form="this.form" :fleet-uuid="fleetUuid" :is-popup="isPopup"></vehicle-form>
        <sp-loader v-if="isLoading"></sp-loader>
    </div>
</template>

<script>
import VehicleForm from '@/views/Vehicles/components/VehicleForm'
import FleetApi from '@/api/FleetApi'
import VehicleApi from '@/api/VehicleApi'
import { calculateSpeedOrDistanceUnit } from '@/helpers/Utils'
import { mapGetters } from 'vuex'

import SpLoader from '@/components/atoms/Loader'

const fleetApi = new FleetApi()
const vehicleApi = new VehicleApi()

export default {
    name: 'VehicleCreateFrom',
    components: {
        VehicleForm,
        SpLoader
    },
    props: {
        fleetUuid: {
            type: String,
            required: false,
            default: ''
        },
        isPopup: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isLoading: false,
            form: {
                registration: '',
                manufacturer: '',
                model: '',
                fuelType: null,
                yearOfManufacture: '',
                mileage: 0,
                engineSize: null,
                vehicleType: null,
                chassisNumber: '',
                hexColor: '#AED51B',
                fleet: null
            }
        }
    },
    async mounted () {
        this.isLoading = true

        const currentFleet = await fleetApi.getFleet(this.fleetUuid)
        this.$set(this.form, 'fleet', currentFleet.payload)

        this.isLoading = false
    },
    computed: {
        ...mapGetters('authModule', [
            'getSpeedUnit'
        ])
    },
    methods: {
        async createVehicle (form) {
            const response = await vehicleApi.createVehicle(
                form.fleet.id,
                form.registration,
                form.manufacturer,
                form.model,
                form.fuelType,
                form.yearOfManufacture,
                0 === this.getSpeedUnit ? form.mileage : calculateSpeedOrDistanceUnit(form.mileage, 'km'),
                form.engineSize,
                form.vehicleType,
                form.chassisNumber,
                form.hexColor
            )

            if (!response.isSuccess) {
                return
            }

            if (this.isPopup) {
                this.$emit('success', true)
            } else {
                if (this.hasAllRoles(['VehicleUpdate'])) {
                    this.$router.push(`/settings/fleets/${form.fleet.id}/vehicle/edit/${response.payload}`)
                }
            }
        }
    }

}
</script>

<style scoped>
</style>
